module.exports = __webpack_public_path__ + "img/wordcloud-pasquale-scudieri.6ec15643.png";